module.exports = __webpack_public_path__ + "img/logo-dr.f1c7f7d.png";